import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {localReferentielAction} from "../localReferentiel/state/localReferentielActions";

const useLocalReferentiel = (localReferentielKeys = []) => {
  const localReferentielData = useSelector((state) => state.localReferentiel);

  const dispatch = useDispatch();

  React.useEffect(() => {
    const localReferentielKeysValues = Object.values(localReferentielKeys);
    if (Array.isArray(localReferentielKeys)) {
      localReferentielKeys.forEach((localReferentielKey) => {
        if (
          !localReferentielData[localReferentielKey].isSuccessed &&
          !localReferentielData[localReferentielKey].isLoading &&
          localReferentielKeysValues.includes(localReferentielKey)
        ) {
          dispatch(localReferentielAction(localReferentielKey));
        }
      });
    } else if (
      (typeof localReferentielKeys === "string" ||
        localReferentielKeys instanceof String) &&
      localReferentielKeysValues.includes(localReferentielKeys) &&
      !localReferentielData[localReferentielKeys].isSuccessed &&
      !localReferentielData[localReferentielKeys].isLoading
    ) {
      dispatch(localReferentielAction(localReferentielKeys));
    } else {
      throw new Error("useLocalReferentiel : Clé invalide");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let returnedArray = [];

  if (Array.isArray(localReferentielKeys)) {
    returnedArray = localReferentielKeys.map(
      (localReferentielKey) => localReferentielData[localReferentielKey]
    );
  } else if (
    typeof localReferentielKeys === "string" ||
    localReferentielKeys instanceof String
  ) {
    returnedArray.push(localReferentielData[localReferentielKeys]);
  } else {
    throw new Error("useLocalReferentiel : Clé invalide");
  }

  return returnedArray;
};

export default useLocalReferentiel;
